export function canNativeShareImage(): boolean {
  if (typeof navigator === 'undefined' || !navigator.share || !navigator.canShare) {
    return false;
  }
  try {
    const probe = new File([''], 'story.png', { type: 'image/png' });
    return navigator.canShare({ files: [probe] });
  } catch {
    return false;
  }
}

export async function canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((result) => {
      if (result) resolve(result);
      else reject(new Error('Không thể tạo ảnh PNG'));
    }, 'image/png');
  });
  return blob;
}

function blobToPngFile(blob: Blob, filename: string): File {
  return new File([blob], `${filename}.png`, { type: 'image/png' });
}

function downloadPngFile(file: File): void {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.download = file.name;
  link.href = url;
  link.click();
  URL.revokeObjectURL(url);
}

export type StoryImageShareMode = 'shared' | 'downloaded';

/** Mobile (iOS Safari, Android Chrome…): mở sheet chia sẻ native. Desktop: tải file. */
export async function shareOrDownloadPngBlob(
  blob: Blob,
  filename: string,
  preferShare = canNativeShareImage()
): Promise<StoryImageShareMode> {
  const file = blobToPngFile(blob, filename);

  if (preferShare) {
    await navigator.share({
      files: [file],
      title: 'Date.Mut.Vn — Quiz Story',
    });
    return 'shared';
  }

  downloadPngFile(file);
  return 'downloaded';
}

/** Mobile (iOS Safari, Android Chrome…): mở sheet chia sẻ native. Desktop: tải file. */
export async function shareOrDownloadStoryImage(
  canvas: HTMLCanvasElement,
  filename: string,
  preferShare = canNativeShareImage()
): Promise<StoryImageShareMode> {
  const blob = await canvasToPngBlob(canvas);
  return shareOrDownloadPngBlob(blob, filename, preferShare);
}

export function isShareCancelled(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}